import React, { useContext } from 'react';
import { ChartContainer } from './PPAInsightPieCharts.style';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
import { AppContext } from '../../../../../../Context/AppContext';

const COLORS = ['#92b100', '#dd1d21'];

// Accept tradeName as a prop
export const PptInScopeVsOutScope: React.FC<{ tradeName: string }> = ({ tradeName }) => {
  const { state: pptState } = useContext(AppContext).pptReports;

  // Filter volumes based on the tradeName prop
  const [filteredVolumes] = pptState.pptInScopeVsOutScopeVolume.filter(
    (volume) => volume.tradeName === tradeName,
  );

  const inScopeQuantity = filteredVolumes?.inScopeQty;
  const totalQuantity = filteredVolumes?.totalQty;
  const outOfScopeQuantity = filteredVolumes?.outOfScopeQty;

  // Calculate percentages
  const inScopePercentage = (inScopeQuantity / totalQuantity) * 100;
  const outOfScopePercentage = (outOfScopeQuantity / totalQuantity) * 100;

  // Prepare chart data
  const chartData = [
    { name: 'In Scope', qty: inScopeQuantity, y: inScopePercentage, color: '#92b100' },
    { name: 'Out of Scope', qty: outOfScopeQuantity, y: outOfScopePercentage, color: '#dd1d21' },
  ];

  const pieChartData = chartData.map(item => ({
    name: item.name,
    value: item.qty,
    percentage: item.y,
  }));

  // Conditionally render the chart or a no data message
  return (
    <ChartContainer>
      {totalQuantity > 0 ? (
        <>
          <div style={{ width: '100%', height: '400px' }}>
            <h3 style={{ textAlign: 'left', marginBottom: '0.5rem' }}>
              {tradeName} - In Scope vs Out of Scope
            </h3>
            <p style={{ textAlign: 'left', fontSize: '0.875rem', color: '#666', marginBottom: '1rem' }}>
              An overview of In Scope vs Out of Scope for {tradeName}
            </p>
            <ResponsiveContainer width="100%" height="80%">
              <PieChart>
                <Pie
                  data={pieChartData}
                  cx="50%"
                  cy="50%"
                  labelLine={true}
                  label={({ percent }) => `${((percent ?? 0) * 100).toFixed(3)}%`}
                  outerRadius={100}
                  fill="#8884d8"
                  dataKey="value"
                >
                  {pieChartData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                  ))}
                </Pie>
                <Tooltip 
                  formatter={(value, name, props) => [
                    `${Number(value ?? 0).toFixed(3)} (${props.payload.percentage.toFixed(3)}%)`,
                    name
                  ]}
                />
                <Legend verticalAlign="top" height={36} />
              </PieChart>
            </ResponsiveContainer>
          </div>
          <div
            style={{ display: 'none' }}
            data-testid='report-breakdown-inScopeVsOutOfScope-chart-hidden-for-automation'
          >
            {JSON.stringify(pieChartData)}
          </div>
        </>
      ) : (
        <div>No data available for {tradeName}</div>
      )}
    </ChartContainer>
  );
};
